export enum OnboardingStep {
  STEP_ONE = 'step_one',
  STEP_TWO = 'step_two',
  COMPLETED = 'complete',
}
